import {
  SALESFORCE_ACCOUNTS,
  SALESFORCE_ATTRIBUTES,
  SALESFORCE_OAUTH_URL,
  SALESFORCE_REVOKE_TOKEN,
  SALESFORCE_AVAILABLE_TAGS,
} from '@mm/api-routes';
import {
  SalesForceAccount,
  SalesForceAttribute,
  SalesForceTags,
} from '../model/SalesForceModel';
import AuthenticatedController from './AuthenticatedController';

export default class SalesForceController extends AuthenticatedController {
  static async getOauthUrl(tokenId?: number) {
    const query = tokenId ? { token_id: tokenId } : undefined;
    return super.get(SALESFORCE_OAUTH_URL, query);
  }
  static async getAccounts(facebokPageId: number): Promise<SalesForceAccount> {
    return super.get(SALESFORCE_ACCOUNTS, {
      facebook_page_id: facebokPageId,
    });
  }
  static async revokeAccess(accountId: number) {
    return super.post(SALESFORCE_REVOKE_TOKEN, {
      account_id: accountId,
    });
  }
  static async getAttributes(
    facebookPageId: number,
    tokenId: number,
    force?: boolean,
  ): Promise<SalesForceAttribute[]> {
    return super.get(SALESFORCE_ATTRIBUTES, {
      facebook_page_id: facebookPageId,
      token_id: tokenId,
      force,
    });
  }

  static async getAvailableTags(
    facebookPageId: number,
    tokenId: number,
  ): Promise<SalesForceTags> {
    return super.get(SALESFORCE_AVAILABLE_TAGS, {
      facebook_page_id: facebookPageId,
      token_id: tokenId,
    });
  }
}
